export default {"src":"/_next/static/media/insufficient-airdrop-fee-tokens-illustration.5f6f5a97.svg","height":174,"width":181,"blurWidth":0,"blurHeight":0};